<template>
  <div class="site-background">
    <br aria-hidden="true" />
    <br aria-hidden="true" />
    <ProgressBars></ProgressBars>
    <br aria-hidden="true" />

    <div v-show="newVersion()">
      <br aria-hidden="true" />
      <div class="quiz-container-new">
        <div class="quiz-text-bubble-new">
          <br aria-hidden="true" />
          <div class="centered-element">
            <AvatarIcon width="100"></AvatarIcon>
            <div class="bonus-star" v-show="barsIncremented" aria-hidden="true">+ <font-awesome-icon icon="star" /></div>
          </div>
          <br aria-hidden="true" />
          <!-- <h2 class="progression-heading" v-html="LG('QR_heading1')"></h2> -->
          <br aria-hidden="true" />
          <p v-html="LG('QR_paragraph1')"></p>
          <div class="centered-element my-3 py-2">
            <div class="button-wrapper d-flex justify-content-center py-2">
              <span class="section-num mr-4" aria-hidden="true">1</span>
              <a class="survez-link btn btn-secondary" target="_blank" :href="surveyPath" v-on:click="onSurveyLinkClicked()" v-html="LG('QR_surveyShortText')"></a>
            </div>
            <div class="button-wrapper d-flex justify-content-center py-2">
              <span class="section-num mr-4" aria-hidden="true">2</span>
              <b-button class="funky-shape" v-on:click="onStartButtonClicked()">{{ LG("QR_startButtonLabel") }}</b-button>
            </div>
          </div>
        </div>
        <div class="quiz-area-new">
          <br aria-hidden="true" />
          <div class="selection-area-new bg-popup-area-new push-display-right">
            <hr />
            <div class="row">
              <div class="col-sm-3">
                <strong><span v-html="getCategoryLabel(0)"></span></strong>
              </div>
              <div class="col-sm-9"><ProgressBar bar="0"></ProgressBar><br aria-hidden="true" /></div>
            </div>
            <p v-html="getCategoryText(0)"></p>
            <hr />
            <div class="row">
              <div class="col-sm-3">
                <strong><span v-html="getCategoryLabel(1)"></span></strong>
              </div>
              <div class="col-sm-9"><ProgressBar bar="1"></ProgressBar><br aria-hidden="true" /></div>
            </div>
            <p v-html="getCategoryText(1)"></p>
            <hr />
            <div class="row">
              <div class="col-sm-3">
                <strong><span v-html="getCategoryLabel(2)"></span></strong>
              </div>
              <div class="col-sm-9"><ProgressBar bar="2"></ProgressBar><br aria-hidden="true" /></div>
            </div>
            <p v-html="getCategoryText(2)"></p>
            <hr />
            <div class="row">
              <div class="col-sm-3">
                <strong><span v-html="getCategoryLabel(3)"></span></strong>
              </div>
              <div class="col-sm-9"><ProgressBar bar="3"></ProgressBar><br aria-hidden="true" /></div>
            </div>
            <p v-html="getCategoryText(3)"></p>
            <hr />
            <!-- <div class="survey-text" align="center">
              <a target="_blank" :href="surveyPath" v-on:click="onSurveyLinkClicked()" v-html="LG('QR_surveyText')"></a>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <br aria-hidden="true" />
    <br aria-hidden="true" />
    <AudioPlayer id="sfxStarEarned-id" ref="sfxStarEarnedRef" autoplay="no" :url="sfxStarEarned" registered="no"></AudioPlayer>
    <div v-if="hasBravoAudio()">
      <AudioPlayer id="id-Bravo-audio" :ref="getBravoAudioRef()" autoplay="yes" @audio-ended="onBravoAudioEnded()" :url="getBravoAudio()"></AudioPlayer>
    </div>
    <div v-if="hasContentAudio()">
      <AudioPlayer id="id-recap-audio" :ref="getContentAudioRef()" autoplay="no" :url="getContentAudio()"></AudioPlayer>
    </div>
  </div>
</template>

<script>
import ProgressBars from "../components/ProgressBars.vue";
import ProgressBar from "../components/ProgressBar.vue";
import AvatarIcon from "../components/AvatarIcon.vue";
import AudioPlayer from "../components/AudioPlayer.vue";

export default {
  components: {
    ProgressBars,
    ProgressBar,
    AvatarIcon,
    AudioPlayer,
  },
  data() {
    return {
      areaName: this.$route.params.areaName,
      situationName: this.$route.params.situationName,

      // Arrays
      situations: [
        {
          id: "id-situation-1",
          categories: [
            {
              percent: 90,
              text: this.LG("QR_S1_text1"),
            },
            {
              percent: 50,
              text: this.LG("QR_S1_text2"),
            },
            {
              percent: 50,
              text: this.LG("QR_S1_text3"),
            },
            {
              percent: 90,
              text: this.LG("QR_S1_text4"),
            },
          ],
          audioUrl: "/audio/scene1/L'accueil des familles_027.mp3",
        },
        {
          id: "id-situation-2",
          categories: [
            {
              percent: 50,
              text: this.LG("QR_S2_text1"),
            },
            {
              percent: 90,
              text: this.LG("QR_S2_text2"),
            },
            {
              percent: 90,
              text: this.LG("QR_S2_text3"),
            },
            {
              percent: 50,
              text: this.LG("QR_S2_text4"),
            },
          ],
          audioUrl: "/audio/scene2/L'écoute visible_022.mp3",
        },
        {
          id: "id-situation-3",
          categories: [
            {
              percent: 50,
              text: this.LG("QR_S3_text1"),
            },
            {
              percent: 90,
              text: this.LG("QR_S3_text2"),
            },
            {
              percent: 90,
              text: this.LG("QR_S3_text3"),
            },
            {
              percent: 50,
              text: this.LG("QR_S3_text4"),
            },
          ],
          audioUrl: "/audio/scene3/Un milieu inclusif et stimulant pour tous_22.mp3",
        },
        {
          id: "id-situation-4",
          categories: [
            {
              percent: 90,
              text: this.LG("QR_S4_text1"),
            },
            {
              percent: 50,
              text: this.LG("QR_S4_text2"),
            },
            {
              percent: 10,
              text: this.LG("QR_S4_text3"),
            },
            {
              percent: 90,
              text: this.LG("QR_S4_text4"),
            },
          ],
          audioUrl: "/audio/scene4/Ici, je suis chez moi_022.mp3",
        },
        {
          id: "id-situation-5",
          categories: [
            {
              percent: 90,
              text: this.LG("QR_S5_text1"),
            },
            {
              percent: 10,
              text: this.LG("QR_S5_text2"),
            },
            {
              percent: 50,
              text: this.LG("QR_S5_text3"),
            },
            {
              percent: 50,
              text: this.LG("QR_S5_text4"),
            },
          ],
          audioUrl: "/audio/scene5/Nature et découverte_022.mp3",
        },
        {
          id: "id-situation-6",
          categories: [
            {
              percent: 90,
              text: this.LG("QR_S6_text1"),
            },
            {
              percent: 50,
              text: this.LG("QR_S6_text2"),
            },
            {
              percent: 50,
              text: this.LG("QR_S6_text3"),
            },
            {
              percent: 50,
              text: this.LG("QR_S6_text4"),
            },
          ],
          audioUrl: "/audio/scene6/Un environnement riche_022.mp3",
        },
        {
          id: "id-situation-7",
          categories: [
            {
              percent: 90,
              text: this.LG("QR_S7_text1"),
            },
            {
              percent: 90,
              text: this.LG("QR_S7_text2"),
            },
            {
              percent: 50,
              text: this.LG("QR_S7_text3"),
            },
            {
              percent: 90,
              text: this.LG("QR_S7_text4"),
            },
          ],
          audioUrl: "/audio/scene7/Cultiver des saines habitudes de vie_022.mp3",
        },
        {
          id: "id-situation-8",
          categories: [
            {
              percent: 90,
              text: this.LG("QR_S8_text1"),
            },
            {
              percent: 50,
              text: this.LG("QR_S8_text2"),
            },
            {
              percent: 50,
              text: this.LG("QR_S8_text3"),
            },
            {
              percent: 50,
              text: this.LG("QR_S8_text4"),
            },
          ],
          audioUrl: "/audio/scene8/On joue dehors_022.mp3",
        },
        {
          id: "id-situation-9",
          categories: [
            {
              percent: 50,
              text: this.LG("QR_S9_text1"),
            },
            {
              percent: 90,
              text: this.LG("QR_S9_text2"),
            },
            {
              percent: 90,
              text: this.LG("QR_S9_text3"),
            },
            {
              percent: 50,
              text: this.LG("QR_S9_text4"),
            },
          ],
          audioUrl: "/audio/scene9/MES1-8-1.mp3",
        },
        {
          id: "id-situation-10",
          categories: [
            {
              percent: 50,
              text: this.LG("QR_S10_text1"),
            },
            {
              percent: 90,
              text: this.LG("QR_S10_text2"),
            },
            {
              percent: 50,
              text: this.LG("QR_S10_text3"),
            },
            {
              percent: 90,
              text: this.LG("QR_S10_text4"),
            },
          ],
          audioUrl: "/audio/scene10/MES2-8-1.mp3",
        },
        {
          id: "id-situation-11",
          categories: [
            {
              percent: 90,
              text: this.LG("QR_S11_text1"),
            },
            {
              percent: 90,
              text: this.LG("QR_S11_text2"),
            },
            {
              percent: 90,
              text: this.LG("QR_S11_text3"),
            },
            {
              percent: 10,
              text: this.LG("QR_S11_text4"),
            },
          ],
          audioUrl: "/audio/scene11/MES3-8-1.mp3",
        },
        {
          id: "id-situation-12",
          categories: [
            {
              percent: 90,
              text: this.LG("QR_S12_text1"),
            },
            {
              percent: 90,
              text: this.LG("QR_S12_text2"),
            },
            {
              percent: 10,
              text: this.LG("QR_S12_text3"),
            },
            {
              percent: 90,
              text: this.LG("QR_S12_text4"),
            },
          ],
          audioUrl: "/audio/scene12/MES4-8-1.mp3",
        },
      ],

      // Audio
      audioBravo: "/audio/partager/partager_quizrecap_bravo.mp3",
      sfxStarEarned: "/audio/sfx/SFX_CollectStar.mp3",

      // Images

      // Variables
      barsIncremented: false,
      surveyPath: "https://fr.surveymonkey.com/r/CFPEAutoformations",
    };
  },
  computed: {},
  created() {
    this.setArea(this.areaName);
    this.setSituation(this.situationName);
  },
  mounted() {
    this.showProgressBars(false);

    if (this.isSituationIsComplete()) {
      // Don't show the increment and earning of stars, etc until a second passes
      // setTimeout(() => this.showProgressBars(true), 3850);
      setTimeout(() => this.showProgressBars(true), 1500);
    }
  },
  methods: {
    isSituationIsComplete() {
      const situationNum = this.getCurrentSituation();

      const watchedSituationVideo = this.$store.state.gamestate.watchedSituationVideo[situationNum];

      var allClueFound = false;
      const cluesSituation = this.$store.state.gamestate.clues.slice(situationNum * 6, situationNum * 6 + 6);
      const NumberOfCluesFounded = cluesSituation.filter((value) => value).length;
      // If all clues are found
      if (NumberOfCluesFounded >= 5) {
        allClueFound = true;
      }

      // const cameFromStroyline = document.referrer.endsWith("jeu.html");

      return watchedSituationVideo && allClueFound; // && cameFromStroyline;
    },
    getCategoryLabel(index) {
      var categoryNum = Number(index) + 1;
      var tag = "QR_category" + categoryNum;
      //var percent = this.getBarOverride(index); // Old way where we are describing this specific MES
      var percent = Math.round(this.getProgressBarValue(index));
      return this.LG(tag) + ": " + percent + "%";
    },
    onSurveyLinkClicked() {
      this.pauseAllAudio();
    },
    onStartButtonClicked() {
      // If you click the continue button before the bars have incremented, increment them now before leaving page
      if (!this.barsIncremented) {
        this.showProgressBars(true);
      }
      this.$router.push("/environment");
    },
    getCurrentSituation() {
      return this.$store.state.gamestate.situation;
    },
    getCategoryText(index) {
      return this.situations[this.getCurrentSituation()].categories[index].text;
    },
    getTotalPercentForCategory(category) {
      var total = 0;
      for (var i = 0; i < this.situations.length; i++) {
        total += this.situations[i].categories[category].percent;
      }
      return total;
    },
    getCompletedPercentForCategory(category) {
      var total = 0;
      for (var i = 0; i < this.situations.length; i++) {
        if (this.$store.state.gamestate.completed[i] == true) {
          total += this.situations[i].categories[category].percent;
        }
      }
      return total;
    },
    showProgressBars(markCompletion) {
      if (markCompletion) {
        // Show the change in stars in the progress bar, and save progress
        this.$store.commit("setSituationComplete", this.getCurrentSituation());
        this.saveGameState();

        this.barsIncremented = true;

        var audioRef = this.$refs["sfxStarEarnedRef"];
        if (audioRef != null) {
          audioRef.playAudio();
        }
      } else {
        // To make it easier to see the animation, let's artifically mark the situation as incomplete at the start
        // So going back to this page shows animation again, why not?
        this.$store.commit("setSituationReset", this.getCurrentSituation());
      }

      var total1 = (this.getCompletedPercentForCategory(0) / this.getTotalPercentForCategory(0)) * 100;
      var total2 = (this.getCompletedPercentForCategory(1) / this.getTotalPercentForCategory(1)) * 100;
      var total3 = (this.getCompletedPercentForCategory(2) / this.getTotalPercentForCategory(2)) * 100;
      var total4 = (this.getCompletedPercentForCategory(3) / this.getTotalPercentForCategory(3)) * 100;

      this.$store.commit("setProgressWellBeing", total1);
      this.$store.commit("setProgressEngagement", total2);
      this.$store.commit("setProgressExpression", total3);
      this.$store.commit("setProgressMembership", total4);

      this.saveGameState();
    },
    getBarOverride(index) {
      return String(this.situations[this.getCurrentSituation()].categories[index].percent);
    },
    hasContentAudio() {
      if (this.getContentAudio() == null) {
        return false;
      }
      return true;
    },
    getContentAudio() {
      return this.situations[this.getCurrentSituation()].audioUrl;
    },
    getContentAudioRef() {
      return "contentAudioRef";
    },
    hasBravoAudio() {
      if (this.getBravoAudio() == null) {
        return false;
      }
      return true;
    },
    getBravoAudio() {
      return this.audioBravo;
    },
    getBravoAudioRef() {
      return "bravoAudioRef";
    },
    onBravoAudioEnded() {
      var audioRef = this.$refs[this.getContentAudioRef()];
      if (audioRef != null) {
        audioRef.playAudio();
      }
    },
  },
};
</script>

<style scoped>
.button-wrapper {
  display: flex;
}

.section-num {
  /* position: absolute;
  left: -14px; */

  font-size: 1.6rem;
  font-weight: 600;

  padding-left: 13px;
  padding-right: 13px;
  padding-bottom: 2px;
  padding-top: 3px;

  background-color: #e8eff2;
  color: #154f68;
  border: solid 7px #fff;
  border-radius: 50%;

  font-variant-numeric: tabular-nums;
}
@media (max-width: 400px) {
  .section-num {
    position: relative;
  }
}
.survez-link {
  color: #fff !important;
  display: inline-block;
  width: 160px;
  height: 50px;
  padding: 13px 30px;

  clip-path: polygon(10% 20%, 85% 0%, 100% 100%, 0% 100%);
  background-color: #154f68;
  color: white;
  text-align: center;
  font-family: "Poppins";
}
.survez-link:hover,
.survez-link:focus,
.survez-link:active {
  background-color: #5a6268;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@import url("https://fonts.googleapis.com/css?family=Nunito");
@import url("https://fonts.googleapis.com/css?family=Poppins");

.survey-text {
  font-size: 20px;
  /*font-weight: bold;*/
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.survey-text a:link {
  text-decoration: underline !important;
}

.survey-text a:visited {
  text-decoration: underline !important;
}

.survey-text a:hover {
  color: darkblue !important;
}

.survey-text a:active {
  color: darkblue !important;
}

.bg-select-area {
  background-color: white;
  color: black;
  font-size: 17px;
  max-width: 1000px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
}

.selection-area {
  margin-top: 0px;
  margin-right: 25px;
  background-color: white;
  padding: 10px;
  font-family: "Poppins";
  font-size: 14px;
  min-height: 400px;
}

.selection-area-new {
  margin-top: 0px;
  margin-right: 25px;
  background-color: white;
  padding: 10px;
  font-family: "Poppins";
  font-size: 17px;
  min-height: 400px;
}

.bg-color-box-green {
  background-color: #3f5d12;
  border: 1px solid #8cbbe9;
  padding: 14px;
  color: white;
  min-height: 615px;
  margin-left: 20px;
  margin-top: 20px;
  margin-bottom: 25px;
  margin-right: 0px;
  font-family: "Nunito";
  font-size: 17px;
}

.button-white {
  background-color: white !important;
  color: darkgreen !important;
}

.button-white:hover {
  background-color: darkseagreen !important;
  color: white !important;
}

.progression-heading {
  font-size: 24px;
}

.push-display-right {
  padding-left: 370px;
  padding-top: 50px;
  padding-right: 50px;
  padding-bottom: 50px;
  border-radius: 55px !important;
}

.quiz-container-new {
  position: relative;
  top: 0px;
  left: 0px;
  z-index: 0;
}

.quiz-area-new {
  max-width: 1300px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.quiz-text-bubble-new {
  position: absolute;
  top: 10%;
  left: 0px;
  max-width: 400px;
  background-color: #e8eff2;
  color: black;
  font-weight: bold;
  font-family: "Nunito";
  font-size: 17px;
  border-radius: 50px;
  border: 10px solid #ffffff;
  padding: 25px;
  z-index: 1;
}

.bonus-star {
  padding-top: 10px;
  font-size: 20px;
  font-weight: bold;
  color: #ffa500;
  filter: drop-shadow(-2px 2px 2px gray);
}

@media only screen and (max-width: 1400px) {
  .quiz-text-bubble-new {
    position: relative;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  .quiz-area-new {
    padding-top: 50px;
  }

  .push-display-right {
    padding-left: 50px;
  }
}
</style>
